import React from 'react';

import * as UK from 'components/primitives/content';

export const EmptyState = ({ children }) => {
  return <UK.Description>{children}</UK.Description>;
};
